module.exports = ".demog-col{margin-left:auto;margin-right:auto}\n"